<template>
    <div class="share-details text-center">
        <div class="share-details-inner">
            <p class="montserrat-400">
                Don't keep all the good stuff to yourself &mdash; share
                with your friends so they can get in on the insider insights too.
            </p>
            <button class="subscription-cta bg-teal text-white uppercase montserrat-800" @click="click">Share Now</button>
        </div>
        <div class="" v-if="error">
            <span class="label label-danger">
                Failed to copy url. Please copy from the field below.
            </span>
            <div class="flex justify-center mt-4">
                <input id="share_url" class="w-1/2 form-control" type="text" readonly :value="url">
            </div>
        </div>
        <div v-if="copied">
            <span class="label label-success">Referral URL copied to clipboard!</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['url'],
    data() {
        return {
            error: false,
            copied: false,
        }
    },
    methods: {
        async click() {
            try {
                await navigator.clipboard.writeText(this.url);
                this.copied = true;
            } catch (error) {
                this.error = true;
            }
        }
    }
};
</script>
